import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Facebook } from 'lucide-react';
import { ContactChannels } from '../ContactChannels';
import { contact } from '../../config/contact';
import { trackCtaClick } from '../../lib/analytics';

export function Footer() {
  const { t } = useTranslation('common');
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-100 border-t border-white/5">
      <div className="max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="font-bold text-lg tracking-tight cursor-pointer transition-opacity hover:opacity-80">
              <span className="text-neon-cyan">Happy</span>
              <span className="text-white">Tech</span>
            </Link>
            <p className="mt-3 text-sm text-text-secondary leading-relaxed">
              {t('footer.tagline')}
            </p>
            {contact.sameAs.filter((url) => url.includes('facebook.com')).length > 0 && (
              <a
                href={contact.sameAs.find((url) => url.includes('facebook.com'))}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-flex items-center gap-2 text-sm text-text-secondary hover:text-neon-cyan transition-colors"
              >
                <Facebook className="w-4 h-4" />
                Facebook
              </a>
            )}
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-sm font-semibold text-text-primary mb-4">{t('footer.navigation')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-text-secondary hover:text-neon-cyan transition-colors cursor-pointer">
                  {t('nav.services')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-text-secondary hover:text-neon-cyan transition-colors cursor-pointer">
                  {t('nav.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold text-text-primary mb-4">{t('footer.getInTouch')}</h3>
            <Link
              to="/contact"
              onClick={() => trackCtaClick('footer')}
              className="inline-flex items-center text-sm bg-gradient-to-r from-neon-cyan to-neon-purple text-white font-medium transition-all duration-300 cursor-pointer px-4 py-2 rounded-xl hover:shadow-glow-cyan"
            >
              {t('footer.startProject')}
              <svg className="ml-1 w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Link>
            <div className="mt-4">
              <ContactChannels />
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/5">
          <p className="text-sm text-text-muted text-center">
            © {currentYear} HappyTech. {t('footer.allRightsReserved')}
          </p>
        </div>
      </div>
    </footer>
  );
}
